            
<template>  
  <div>
    <div class="modalsave" v-show="saveConfig.capa"></div>
    <div>
      <validation-observer v-slot="{ invalid }">  
        <!-- <FormVInput
          v-model="registroPlanilla.planill"
        /> -->
        <SwTableform
          :tableItems="beneficiariosItems"
          tableTabla="servicios_nuevos"
          :tableCampos="['iniciolabores']"
          :inits="beneficiariosInits" />
      <footer id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
            <sw-saveform
              :index="dataIndex[namePath]"
              nameBtn="Quitar # planilla"
              :invalid="invalid"
              @save="save"
              >
            </sw-saveform>
      </footer>
    </validation-observer>
    </div>
  </div> 
</template>
<script>
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import { ValidationProvider } from 'vee-validate'
import SwTableform from '@/components/dataTable/tableForm.vue'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
// import FormVInput from '@/components/Form/VInput.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    SwSaveform,
    ValidationProvider,
    VueNumeric,
    SwTableform,
    // FormVInput
  },
  props: {
    items: {
      type: Array,
      default: ''
    },
  },
  data()
  {
    return {
      registroPlanilla: {
        planilla: null,
      },
			beneficiariosItems: [
				{
					thead: {th: "Documento"},
					tbody: {td: ["id_list_documento"] }
				},
				{
					thead: {th: "Nombres"},
					tbody: {td: ["name"] }
				},
				{
					thead: {th: "Inicio Labores", style: "width: 130px"},
					tbody: {td: ["iniciolabores"] }
				},
				{
					thead: {th: "Archivo"},
					tbody: {td: ["archivo"] }
				},
			],
			beneficiariosInits: [],
    }
  },
  async created()
  {
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  methods: {
    async save(emit)
    {
      this.$emit('save', { save: emit.save, ftn: 'quitarPLanillaFtn', data: this.registroPlanilla })
    },
    sortedTable()
    {
      let vm = this;
      let popoverMap = []      
        let dataFilter = this.deepCopyTable(this.dataGet[this.namePath].data).filter(list => {
          return this.tableSearch.find( items => {
              return cleanParameter(list[items]).indexOf(cleanParameter(this.currentSearch)) > -1
            })         
        })   
        return dataFilter.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier
          if(a[this.currentSort] > b[this.currentSort]) return  1 * modifier
          return 0
        }); 
    },  
  }
}
</script>
<style>
</style>